import { type IVariant } from 'unleash-proxy-client'
import { computed, ref, type ComputedRef, type Ref } from 'vue'

import { FeatureFlags } from '@/plugins/featureFlags'

// Single module-scoped subscription shared by every consumer, so there is
// nothing to leak and no onMounted/onScopeDispose requirement — works in
// Pinia stores, plain composables, and component setup alike.
const version = ref(0)
let subscribed = false

// Deferred to first use, not import time, so importing this module has no side effect.
const ensureSubscribed = (): void => {
  if (subscribed) return
  subscribed = true
  FeatureFlags.on('update', () => {
    version.value++
  })
}

export const useFlagsVersion = (): Readonly<Ref<number>> => {
  ensureSubscribed()
  return version
}

export const useFlag = (flagName: string): ComputedRef<boolean> => {
  ensureSubscribed()
  return computed(() => {
    void version.value
    return FeatureFlags.isEnabled(flagName)
  })
}

export const useFlagVariant = (flagName: string): ComputedRef<IVariant> => {
  ensureSubscribed()
  return computed(() => {
    void version.value
    return FeatureFlags.getVariant(flagName)
  })
}
